import { useEffect, useState } from 'react';
import HeadingWithDescription from '../../../components/headingWithDescription';
import { Box, Card, Divider, Stack, Typography } from '@mui/material';
import { AccountInformation } from '../../../types/manageAccount.type';
import ManageAccountService from '../../../services/manageAccount.service';
import ActivityIndicator from '../../../components/activityIndicator';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
// import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api';
// import locationIcon from '../../../assets/myServiceIcons/map-marker.png';
// import { MAP_API_KEY } from '../../../utils/environment';

// const containerStyle = {
//   width: '100%',
//   height: '400px',
// };

// function SelectLocation({
//   open,
//   setOpen,
//   handleSelect,
//   address,
// }: {
//   open: boolean;
//   setOpen: any;
//   handleSelect: any;
//   address: Address;
// }) {
//   const markerPosition = null;
//   const { isLoaded } = useJsApiLoader({
//     id: 'google-map-script',
//     googleMapsApiKey: MAP_API_KEY,
//   });

//   const [coords, setCoords] = useState<{ lat: String; lng: String }>({
//     lat: address?.Latitude ?? '30.681883660252584',
//     lng: address?.Longitude ?? '76.7264488782959',
//   });

//   const onLoad = React.useCallback(function callback(map: any) {
//     // This is just an example of getting and using the map instance!!! don't just blindly copy!
//     navigator.geolocation.getCurrentPosition(
//       (position) => {
//         let latitude = address?.Latitude ?? position.coords.latitude;
//         let longitude = address?.Longitude ?? position.coords.longitude;
//         if (
//           !address?.Longitude ||
//           !address?.Latitude ||
//           address?.Latitude === '0' ||
//           address?.Longitude === '0'
//         ) {
//           latitude = position.coords.latitude;
//           longitude = position.coords.longitude;
//         }

//         const center = {
//           lat: Number(latitude) ?? 0,
//           lng: Number(longitude) ?? 0,
//         };

//         map.setCenter(center);
//         setCoords({
//           lat: `${latitude}`,
//           lng: `${longitude}`,
//         });

//         const marker: any = new window.google.maps.Marker({
//           position: center,
//           map: map,
//           draggable: true,
//           icon: locationIcon,
//         });

//         google.maps.event.addListener(marker, 'dragend', () => {
//           const newLat = marker.getPosition().lat();
//           const newLng = marker.getPosition().lng();
//           console.log(`New coordinates: ${newLat}, ${newLng}`);
//           let newCoords = {
//             lat: `${newLat}`,
//             lng: `${newLng}`,
//           };
//           map.setCenter(newCoords);

//           setCoords(newCoords);
//         });
//       },
//       (error) => {
//         console.error('Error fetching geolocation data:', error);
//       },
//       {
//         enableHighAccuracy: true,
//         timeout: 5000,
//         maximumAge: 0,
//       },
//     );

//     // eslint-disable-next-line
//   }, []);

//   return (
//     <Modal
//       sx={{
//         flex: 1,
//         display: 'flex',
//         flexDirection: 'column',
//         padding: 1,
//         justifyContent: 'center',
//       }}
//       open={true}
//       onClose={() => setOpen(false)}
//     >
//       <Stack gap={2} p={2} borderRadius={3} bgcolor={'white'}>
//         <Typography variant="h6">PIN LOCATION</Typography>
//         {isLoaded ? (
//           <GoogleMap mapContainerStyle={containerStyle} zoom={18} onLoad={onLoad}>
//             {markerPosition && (
//               <Marker
//                 position={{
//                   lat: Number(address?.Latitude) ?? 0,
//                   lng: Number(address?.Longitude) ?? 0,
//                 }}
//                 draggable={true}
//                 onDragEnd={(e: google.maps.MapMouseEvent) => {
//                   if (e && e?.latLng) {
//                     const newLat = e.latLng.lat();
//                     const newLng = e.latLng.lng();
//                     console.log(`New coordinates: ${newLat}, ${newLng}`);
//                     let newCoords = {
//                       lat: `${newLat}`,
//                       lng: `${newLng}`,
//                     };
//                     setCoords(newCoords);
//                   }
//                 }}
//               />
//             )}
//           </GoogleMap>
//         ) : (
//           <></>
//         )}
//         <Stack direction={'row'} gap={2}>
//           <Button
//             onClick={() => handleSelect(coords)}
//             fullWidth
//             variant="contained"
//             color="secondary"
//           >
//             CONFIRM
//           </Button>
//           <Button onClick={() => setOpen(false)} fullWidth variant="contained" color="secondary">
//             CANCEL
//           </Button>
//         </Stack>
//       </Stack>
//     </Modal>
//   );
// }

export default function Addressess() {
  const [loading, setLoading] = useState(true);
  const [userInfo, setUserInfo] = useState<AccountInformation | null>(null);
  const userId = useSelector((state: RootState) => state.auth?.userId);
  const token = useSelector((state: RootState) => state.auth?.token);
  // const [openMap, setOpenMap] = useState(false);

  const getUserInformation = async (rcn: string) => {
    try {
      if (!token || !rcn) return;
      setLoading(true);
      let res = await ManageAccountService.getAccountInfoAsync(rcn, token);
      setUserInfo(res);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userId) {
      getUserInformation(userId);
    }
    // eslint-disable-next-line
  }, [userId]);

  // const handleSelectLocation = async (coords: { lat: number; lng: number }) => {
  //   if (!userId || !token) return;
  //   try {
  //     setLoading(true);
  //     let res = await ManageAccountService.addCoordsAsync(userId, token, coords?.lat, coords?.lng);
  //     if (res) {
  //       setOpenMap(false);
  //       toast?.success('Location updated.');
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     setLoading(false);
  //     getUserInformation(userId);
  //   }
  // };

  return (
    <Stack p={2} bgcolor={'#f7f7f7'} minHeight={'100vh'}>
      {loading && <ActivityIndicator />}
      <HeadingWithDescription
        heading="Addresses"
        description="We'll deliver your shipment or service your appliances at these saved addresses."
      />

      <Divider sx={{ my: 3 }} />
      {userInfo &&
        userInfo?.address_details?.map((address) => {
          return (
            <div key={address?.zipcode}>
              <Card>
                <Box p={3}>
                  <Typography variant="body1" fontWeight={'500'}>
                    {address?.house_no}, {address?.street}
                  </Typography>
                  <Typography>{address?.line1}</Typography>
                  <Typography>{address?.line2}</Typography>
                  <Typography>{address?.line3}</Typography>
                  <Typography>
                    {address?.city}, {address?.state} {address?.zipcode}
                  </Typography>
                  {/* <Button
                    onClick={() => setOpenMap(true)}
                    sx={{ my: 2 }}
                    size="small"
                    variant="outlined"
                  >
                    Edit Location
                  </Button> */}
                </Box>
                {/* {openMap && (
                  <SelectLocation
                    open={openMap}
                    setOpen={setOpenMap}
                    handleSelect={handleSelectLocation}
                    address={address}
                  />
                )} */}
              </Card>
            </div>
          );
        })}
    </Stack>
  );
}
